function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50C0 22.3858 22.3858 0 50 0C77.6142 0 100 22.3858 100 50Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M83.823 32.14C81.4747 33.1814 78.9511 33.8853 76.3024 34.2018C79.006 32.5812 81.082 30.0151 82.0597 26.9576C79.5298 28.458 76.7275 29.5477 73.7449 30.1351C71.3563 27.5903 67.9533 26 64.1872 26C56.9557 26 51.0928 31.8626 51.0928 39.0938C51.0928 40.12 51.2088 41.1194 51.432 42.0777C40.5495 41.5317 30.9012 36.3187 24.443 28.3968C23.3159 30.3307 22.6702 32.58 22.6702 34.9797C22.6702 39.5224 24.9821 43.5303 28.4955 45.8783C26.3489 45.8104 24.33 45.2214 22.5645 44.2406C22.5635 44.2953 22.5635 44.3501 22.5635 44.4052C22.5635 50.7495 27.077 56.0418 33.0671 57.2445C31.9683 57.5438 30.8116 57.7037 29.6172 57.7037C28.7735 57.7037 27.9532 57.6218 27.1539 57.4689C28.82 62.6711 33.6557 66.4567 39.3855 66.5625C34.9042 70.0742 29.2582 72.1676 23.1236 72.1676C22.0667 72.1676 21.0244 72.1057 20 71.9848C25.7947 75.6999 32.6775 77.8675 40.0721 77.8675C64.1567 77.8675 77.327 57.9152 77.327 40.6121C77.327 40.0444 77.3144 39.4797 77.2892 38.9182C79.8473 37.0721 82.0674 34.7658 83.823 32.14Z",
  fill: "white"
});

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.0712aed8.svg";
export { ForwardRef as ReactComponent };